import { gql } from "@apollo/client";


const FETCH_DELIVERY_PLANS = gql`
query {
    deliveryPlans {
        id,
        planId,
        name,
        value,
        enabled
    }
}
`;

/** @description every delivery method row with its editable price settings */

const FETCH_DELIVERY_PLAN_SETTINGS = gql`
query {
    adminDeliveryPlanSettings {
        id,
        planId,
        name,
        enabled,
        visibleInB2c,
        masterPriceEnabled,
        masterPrice,
        basePrice,
        minPrice,
        freeDeliveryThreshold,
        truckItemPrice,
        distanceSurcharge,
        bulkDiscountFrom,
        bulkDiscountMultiplier,
        priceFields,
        pricing,
        defaultPricing,
        preciseAdressRequired,
        supportsCourierPickup,
        logoUrl
    }
}
`;

export default {
    FETCH_DELIVERY_PLANS,
    FETCH_DELIVERY_PLAN_SETTINGS,
};

export { FETCH_DELIVERY_PLANS, FETCH_DELIVERY_PLAN_SETTINGS };
